module.exports = __webpack_public_path__ + "static/media/display-2@768.6d3e2fbe.png";